'use strict';
var populationEl = document.querySelectorAll('.population');
var totalRes = document.querySelector('.total-population');
var averageRes = document.querySelector('.average-population');
var populationArray = Array.from(populationEl).map(function(el) {
    var clean = el.textContent.replace(/,/g, '').trim();
    var n = Number(clean);
    return n;
});
var filteredArr = populationArray.filter(function(n) {
    return Number.isFinite(n);
});
if (filteredArr.length === 0) {
    totalRes.textContent = '0';
    averageRes.textContent = '0';
} else {
    var total = filteredArr.reduce(function(acc, curr) {
        return acc + curr;
    }, 0);
    var average = Math.round(total / filteredArr.length);
    totalRes.textContent = total.toLocaleString('en-US');
    averageRes.textContent = average.toLocaleString('en-US');
}

//# sourceMappingURL=js_get_data_DOM.af17e334.js.map
